interface PricingCardPeriodicityProps {
  title: string
  subTitle: string
}

export default function PricingCardPeriodicity({ title, subTitle }: PricingCardPeriodicityProps) {
  return (
    <div>
      <h3 style={{ fontSize: '20px', color: '#fff', marginBottom: '10px' }}>{title}</h3>
      <h4 style={{ fontSize: '21px', fontFamily: 'Migra' }}>{subTitle}</h4>
    </div>
  )
}
